import Icon from "@/components/base/Icon";

interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav
      aria-label="分页导航"
      className="mt-8 flex items-center justify-center gap-2 flex-wrap"
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex items-center justify-center w-9 h-9 rounded-md border border-background-300 text-foreground-600 cursor-pointer transition-colors hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <Icon name="ri-arrow-left-s-line" className="w-4 h-4" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`min-w-[36px] h-9 px-2 rounded-md text-sm cursor-pointer transition-colors ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="flex items-center justify-center w-9 h-9 rounded-md border border-background-300 text-foreground-600 cursor-pointer transition-colors hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <Icon name="ri-arrow-right-s-line" className="w-4 h-4" />
      </button>
    </nav>
  );
}